import React from 'react';
import { API } from "aws-amplify";
import { toast } from "react-toastify";
import { withRouter } from "react-router";
import _ from "lodash";

import Modal from "@/common/Modal";

import CreateTenant from "./CreateTenant";

const TENANT_LABELS = [
    { key: 'engage',   title: 'Engage' },
    { key: 'ready',    title: 'Ready' },
    { key: 'pss',      title: 'PSS' },
    { key: 'churn',    title: 'Churn' },
    { key: 'internal', title: 'Internal' },
];

function highlightMatch(name, query) {
    if (!query.trim()) return name;
    const idx = name.toLowerCase().indexOf(query.trim().toLowerCase());
    if (idx === -1) return name;
    return (
        <>
            {name.slice(0, idx)}
            <mark style={{
                background: 'var(--colorSearchHighlightBg)',
                color: 'var(--colorSearchHighlightText)',
                padding: '0 1px',
                borderRadius: '2px',
            }}>
                {name.slice(idx, idx + query.trim().length)}
            </mark>
            {name.slice(idx + query.trim().length)}
        </>
    );
}

function SupportToolsTenants({ searchInput = '', filters = [], countRef, ...props }) {
    const [tenants, setTenants] = React.useState([]);
    const [createOpen, setCreateOpen] = React.useState(false);

    const loadTenants = () => {
        API.get('Core', '/api/v1/support-tools/tenants')
            .then(response => {
                setTenants(Object.assign([], response));
            },
                error => {
                    toast("Could not load tenants: " + error.response.data.message, { position: "top-center", type: "error" });
                }
            );
    }

    React.useEffect(() => {
        loadTenants();
    }, []);

    const onTenantCreateSuccess = () => {
        loadTenants();
        setCreateOpen(false);
    }

    const visibleTenants = _.sortBy(tenants, 'name').filter(t =>
        (filters.length === 0 || filters.every(k => t[k] === true)) &&
        (searchInput.trim() === '' ||
         (t.name && t.name.toLowerCase().includes(searchInput.trim().toLowerCase())))
    );

    if (countRef) countRef.current = visibleTenants.length;

    return (
        <div className="scrollView">

            <div className="">
                <Modal
                    button={(
                        <div
                            className="addButton"
                            tabIndex={0}
                            role="button"
                            aria-label="Create Tenant"
                            onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setCreateOpen(true); } }}
                        >
                            <div className="buttonIcon" aria-hidden="true" />
                            <div className="buttonTitle">Create Tenant</div>
                        </div>
                    )}
                    content={(<CreateTenant onSuccess={onTenantCreateSuccess} />)}
                    title="Create Tenant"
                    size="large"
                    handleClose={() => setCreateOpen(false)}
                    handleOpen={() => setCreateOpen(true)}
                    open={createOpen}
                />

            </div>

            <div className="surveysList tableView">
                <div className="tableSection">
                    {
                        _.map(visibleTenants, function (tenant, k) {
                            return (
                                <div className="tableCell tenantCell" key={k}>
                                    <div className="cellBody">
                                        <div className="title">{highlightMatch(tenant.name.length > 35 ? tenant.name.substring(0, 35) + '...' : tenant.name, searchInput)}</div>
                                        <div className="subtitle">Tenant {tenant.id}</div>
                                        <div className="tenantLabels" style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                                            {TENANT_LABELS.filter(l => tenant[l.key]).map(l => (
                                                <span className="subtitle labelBadge" key={l.key}>{l.title}</span>
                                            ))}
                                        </div>
                                    </div>

                                    <div
                                        onClick={() => { props.history.push('/support-tools/tenant/' + tenant.id); }}
                                        onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); props.history.push('/support-tools/tenant/' + tenant.id); } }}
                                        className="button small action"
                                        role="button"
                                        tabIndex={0}
                                        aria-label={`Manage ${tenant.name}`}
                                    >
                                        <div className="buttonTitle">Manage</div>
                                    </div>
                                </div>
                            )
                        })
                    }
                    {visibleTenants.length === 0 && (searchInput.trim() !== '' || filters.length > 0) && (
                        <div className="emptyState">No results found</div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default withRouter(SupportToolsTenants);
